import * as React from "react";
import moment from "moment";
import { IFormTypesGroupCategory } from "../../../model/formconfiguration/FormTypesGroupCategory";
import {
  Form,
  Input,
  Checkbox,
  DatePicker,
  Select,
  InputNumber,
  Divider,
  Tooltip
} from "antd";
import {
  ReportingTypeInsertForm,
  ReportingTypePeriodMeasureUnitConstants,
  DateFormats,
  ReportingTypeTag,
  InputNumberConstants
} from "../../../common/Constants";
import TextArea from "antd/lib/input/TextArea";
import Text from "antd/lib/typography/Text";
import SelectInput from "../../components/app/SelectInput";

const ReportingTypeForm = ({
  getFieldDecorator,
  translate,
  rowData,
  codebooks,
  getFieldValue
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
  codebooks: IFormTypesGroupCategory[];
  getFieldValue: any;
}) => {
  return (
    <Form>
      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("reporting_type_form.basicInfo")}
        </Text>
        <div className="ant-form-row-two-items">
          <Form.Item
            label={translate("reporting_type_form.code")}
            style={{ marginRight: 20, minWidth: "100px" }}
          >
            {getFieldDecorator(ReportingTypeInsertForm.Fields.CODE, {
              initialValue: rowData && rowData.code,
              rules: [
                {
                  required: rowData ? false : true,
                  message: translate("reporting_type_form.required_messages", {
                    field: translate("reporting_type_form.code")
                  })
                }
              ]
            })(
              <Input
                readOnly={rowData ? true : false}
                maxLength={
                  ReportingTypeInsertForm.VALIDATION_RULES.CODE_MAX_LENGTH
                }
              />
            )}
          </Form.Item>

          <Form.Item
            label={translate("reporting_type_form.formTypesGroupCategoryCode")}
            className="ant-form-item-width"
            style={{ maxWidth: "80%" }}
          >
            {getFieldDecorator(
              ReportingTypeInsertForm.Fields.FORM_TYPES_GROUP_CATEGORY_CODE,
              {
                initialValue: rowData && rowData.formTypesGroupCategoryCode,
                rules: [
                  {
                    required: true,
                    message: translate(
                      "reporting_type_form.required_messages",
                      {
                        field: translate(
                          "reporting_type_form.formTypesGroupCategoryCode"
                        )
                      }
                    )
                  }
                ]
              }
            )(
              <SelectInput
                placeholder={translate(
                  "reporting_type_form.select_form_group_category_code"
                )}
                showSearch={true}
                notFoundContent={translate("search.no_data")}
                selectOptionKey={"code"}
                selectOptionValue={"name"}
                selectOptions={codebooks}
              />
            )}
          </Form.Item>
        </div>

        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between"
          }}
        >
          <Form.Item
            label={translate("reporting_type_form.name")}
            className="ant-form-item-width"
          >
            {getFieldDecorator(ReportingTypeInsertForm.Fields.NAME, {
              initialValue: rowData && rowData.name,
              rules: [
                {
                  required: true,
                  message: translate("reporting_type_form.required_messages", {
                    field: translate("reporting_type_form.name")
                  })
                }
              ]
            })(
              <Input
                maxLength={
                  ReportingTypeInsertForm.VALIDATION_RULES.NAME_MAX_LENGTH
                }
              />
            )}
          </Form.Item>

          <Form.Item
            label={translate("reporting_type_form.valid")}
            style={{ width: 30, marginLeft: 20 }}
          >
            {getFieldDecorator(ReportingTypeInsertForm.Fields.VALID, {
              valuePropName: "checked",
              initialValue: rowData ? rowData.valid : true
            })(<Checkbox />)}
          </Form.Item>
        </div>
        <Form.Item label={translate("reporting_type_form.tag")}>
          {getFieldDecorator(ReportingTypeInsertForm.Fields.TAG, {
            initialValue: rowData && rowData.tag
          })(
            <Select
              placeholder={translate("reporting_type_form.choose_tag")}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
            >
              <Select.Option key={ReportingTypeTag.INITIAL}>
                {translate("reporting_type_form.initial_tag")}
              </Select.Option>
              <Select.Option key={ReportingTypeTag.YEARLY}>
                {translate("reporting_type_form.yearly_tag")}
              </Select.Option>
            </Select>
          )}
        </Form.Item>
        <Form.Item label={translate("reporting_type_form.description")}>
          {getFieldDecorator(ReportingTypeInsertForm.Fields.DESCRIPTION, {
            initialValue: rowData && rowData.description
          })(
            <TextArea
              autoSize={{ minRows: 3 }}
              maxLength={
                ReportingTypeInsertForm.VALIDATION_RULES.DESCRIPTION_MAX_LENGTH
              }
            />
          )}
        </Form.Item>
      </div>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("reporting_type_form.validPeriod")}
        </Text>
        <div style={{ flexDirection: "row", display: "flex" }}>
          <Form.Item
            label={translate("reporting_type_form.dateFrom")}
            style={{ marginRight: 20 }}
          >
            {getFieldDecorator(ReportingTypeInsertForm.Fields.DATE_FROM, {
              initialValue:
                rowData &&
                rowData.dateFrom &&
                moment(rowData.dateFrom, DateFormats.DATE),
              rules: [
                {
                  required: true,
                  message: translate("reporting_type_form.required_messages", {
                    field: translate("reporting_type_form.dateFrom")
                  })
                }
              ]
            })(
              <DatePicker
                placeholder={translate("reporting_type_form.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
              />
            )}
          </Form.Item>

          <Form.Item label={translate("reporting_type_form.dateTo")}>
            {getFieldDecorator(ReportingTypeInsertForm.Fields.DATE_TO, {
              initialValue:
                rowData && rowData.dateTo
                  ? moment(rowData.dateTo, DateFormats.DATE)
                  : undefined
            })(
              <DatePicker
                placeholder={translate("reporting_type_form.select_date")}
                locale={{ dateFormat: DateFormats.DATE }}
                showToday={false}
              />
            )}
          </Form.Item>
        </div>
      </div>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("reporting_type_form.validPeriodInputData")}
        </Text>
        <div style={{ flexDirection: "row", display: "flex" }}>
          <Form.Item
            label={translate("reporting_type_form.period")}
            style={{ marginRight: 20 }}
          >
            {getFieldDecorator(ReportingTypeInsertForm.Fields.PERIOD, {
              initialValue: rowData && rowData.period,
              rules: [
                {
                  required: true,
                  message: translate("reporting_type_form.required_messages", {
                    field: translate("reporting_type_form.period")
                  })
                }
              ]
            })(<InputNumber min={InputNumberConstants.MIN_VALUE} />)}
          </Form.Item>

          <Form.Item
            label={translate("reporting_type_form.periodMeasureUnit")}
            style={{ marginRight: 20 }}
          >
            {getFieldDecorator(
              ReportingTypeInsertForm.Fields.PERIOD_MEASURE_UNIT,
              {
                initialValue: rowData && rowData.periodMeasureUnit,
                rules: [
                  {
                    required: true,
                    message: translate(
                      "reporting_type_form.required_messages",
                      {
                        field: translate(
                          "reporting_type_form.periodMeasureUnit"
                        )
                      }
                    )
                  }
                ]
              }
            )(
              <Select
                placeholder={translate(
                  "reporting_type_form.select_period_measure_unit"
                )}
                allowClear
                showSearch={true}
                notFoundContent={translate("search.no_data")}
              >
                <Select.Option
                  key={ReportingTypePeriodMeasureUnitConstants.DAY}
                >
                  {translate("reporting_type_form.periodMeasureUnits.day")}
                </Select.Option>
                <Select.Option
                  key={ReportingTypePeriodMeasureUnitConstants.MONTH}
                >
                  {translate("reporting_type_form.periodMeasureUnits.month")}
                </Select.Option>
                <Select.Option
                  key={ReportingTypePeriodMeasureUnitConstants.YEAR}
                >
                  {translate("reporting_type_form.periodMeasureUnits.year")}
                </Select.Option>
              </Select>
            )}
          </Form.Item>
          <Form.Item
            label={
              <Tooltip
                title={translate("reporting_type_form.gracePeriodInDays")}
              >
                {translate("reporting_type_form.gracePeriod")}
              </Tooltip>
            }
          >
            {getFieldDecorator(
              ReportingTypeInsertForm.Fields.GRACE_PERIOD_IN_DAYS,
              {
                initialValue: rowData && rowData.gracePeriodInDays
              }
            )(<InputNumber min={InputNumberConstants.MIN_VALUE} />)}
          </Form.Item>
        </div>
      </div>

      <Divider></Divider>

      <div className="ant-form-row-container">
        <Text style={{ fontWeight: "bold" }}>
          {translate("reporting_type_form.periodOfRepetiton")}
        </Text>
        <div style={{ flexDirection: "row", display: "flex" }}>
          <Form.Item
            label={translate("reporting_type_form.repeatingPeriod")}
            style={{ marginRight: 83 }}
          >
            {getFieldDecorator(
              ReportingTypeInsertForm.Fields.REPEATING_PERIOD,
              {
                valuePropName: "checked",
                initialValue: rowData && rowData.repeatingPeriod
              }
            )(<Checkbox />)}
          </Form.Item>

          {getFieldValue(ReportingTypeInsertForm.Fields.REPEATING_PERIOD) ? (
            <div style={{ flexDirection: "row", display: "flex" }}>
              <Form.Item
                label={translate("reporting_type_form.periodOfRepetiton")}
              >
                {getFieldDecorator(
                  ReportingTypeInsertForm.Fields.PERIOD_OF_REPETITION,
                  {
                    initialValue: rowData && rowData.periodOfRepetiton
                  }
                )(<InputNumber min={InputNumberConstants.MIN_VALUE} />)}
              </Form.Item>
              <Form.Item
                label={translate(
                  "reporting_type_form.periodOfRepetitonMeasureUnit"
                )}
                style={{ width: "100%", marginLeft: 20 }}
              >
                {getFieldDecorator(
                  ReportingTypeInsertForm.Fields
                    .PERIOD_OF_REPETITION_MEASURE_UNIT,
                  {
                    initialValue:
                      rowData && rowData.periodOfRepetitonMeasureUnit
                  }
                )(
                  <Select
                    placeholder={translate(
                      "reporting_type_form.select_repeting_period_measure_unit"
                    )}
                    allowClear
                    showSearch={true}
                    notFoundContent={translate("search.no_data")}
                  >
                    <Select.Option
                      key={ReportingTypePeriodMeasureUnitConstants.DAY}
                    >
                      {translate("reporting_type_form.periodMeasureUnits.day")}
                    </Select.Option>
                    <Select.Option
                      key={ReportingTypePeriodMeasureUnitConstants.MONTH}
                    >
                      {translate(
                        "reporting_type_form.periodMeasureUnits.month"
                      )}
                    </Select.Option>
                    <Select.Option
                      key={ReportingTypePeriodMeasureUnitConstants.YEAR}
                    >
                      {translate("reporting_type_form.periodMeasureUnits.year")}
                    </Select.Option>
                  </Select>
                )}
              </Form.Item>
            </div>
          ) : (
            <div className="ant-form-row-container" style={{ marginTop: -20 }}>
              <Text style={{ fontWeight: "bold" }}>
                {translate("reporting_type_form.npPeriod")}
              </Text>
              <div style={{ flexDirection: "row", display: "flex" }}>
                <Form.Item
                  label={translate("reporting_type_form.npPeriodFrom")}
                  style={{ marginRight: 20 }}
                >
                  {getFieldDecorator(
                    ReportingTypeInsertForm.Fields.NP_PERIOD_FROM,
                    {
                      initialValue:
                        rowData &&
                        rowData.npPeriodFrom &&
                        moment(rowData.npPeriodFrom, DateFormats.DATE)
                    }
                  )(
                    <DatePicker
                      placeholder={translate("reporting_type_form.select_date")}
                      locale={{ dateFormat: DateFormats.DATE }}
                      showToday={false}
                    />
                  )}
                </Form.Item>

                <Form.Item label={translate("reporting_type_form.npPeriodTo")}>
                  {getFieldDecorator(
                    ReportingTypeInsertForm.Fields.NP_PERIOD_TO,
                    {
                      initialValue:
                        rowData && rowData.npPeriodTo
                          ? moment(rowData.npPeriodTo, DateFormats.DATE)
                          : undefined
                    }
                  )(
                    <DatePicker
                      placeholder={translate("reporting_type_form.select_date")}
                      locale={{ dateFormat: DateFormats.DATE }}
                      showToday={false}
                    />
                  )}
                </Form.Item>
              </div>
            </div>
          )}
        </div>
      </div>
    </Form>
  );
};

export default ReportingTypeForm;
